<div class="container-fluid mitra-blog">
  <div class="row breadcrumb-wrapper">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <div class="container">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <app-breadcrumb *ngIf="showBreadCrumb"></app-breadcrumb>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-4">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <div class="container">
        <h1 class="page-sub-title cv-text-dark mb-4">Blogs and Stories</h1>
        <div class="row blog-pills">
          <div class="col-md-7 col-lg-5">
            <ul class="nav nav-pills" id="pills-tab" role="tablist">
              <li class="nav-item" role="presentation">
                <button class="nav-link active" id="pills-all-tab" data-bs-toggle="pill" data-bs-target="#pills-all"
                  type="button" role="tab" aria-controls="pills-all" aria-selected="true"
                  (click)="onTabclick('all')">All</button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link" id="pills-blogs-tab" data-bs-toggle="pill" data-bs-target="#pills-blogs"
                  type="button" role="tab" aria-controls="pills-blogs" aria-selected="false"
                  (click)="onTabclick('blogs')">Blogs</button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link" id="pills-videos-tab" data-bs-toggle="pill" data-bs-target="#pills-videos"
                  type="button" role="tab" aria-controls="pills-videos" aria-selected="false"
                  (click)="onTabclick('videos')">Videos</button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link" id="pills-news-tab" data-bs-toggle="pill" data-bs-target="#pills-news"
                  type="button" role="tab" aria-controls="pills-news" aria-selected="false"
                  (click)="onTabclick('news')">News</button>
              </li>
            </ul>
          </div>
          <div class="col-md-4  col-lg-4 offset-md-1 offset-lg-3 mb-4 mb-md-0">
            <div class="sortby">
              Sort by: <select class="form-select" (change)="sort($event,'')">
                <option>Select</option>
                <option value="N2O">Newest to oldest</option>
                <option value="O2N">oldest to Newest</option>
              </select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="tab-content blog-content" id="pills-tabContent">
              <div class="tab-pane fade show active" id="pills-all" role="tabpanel" aria-labelledby="pills-all-tab">
                <div class="row mb-4 align-items-center high-light">
                  <ng-container *ngIf="(blogAllList?.length == 0 && !productLoaded);else blogFirstValueTemplate">
                    <ng-container *ngFor="let item of skeletonService.generateFake(1);let i = index;">
                      <div class="col-12 col-sm-12 col-md-6 col-lg-7 col-xl-7">
                        <div class="image-wrapper overflow-hidden">
                          <ngx-skeleton height="425


                                                px"></ngx-skeleton>
                        </div>
                      </div>
                      <div class="col-12 col-sm-12 col-md-6 col-lg-5 col-xl-5 info mt-3">
                        <div>
                          <ngx-skeleton height="30px"></ngx-skeleton>
                        </div>
                        <div>
                          <ngx-skeleton height="100px"></ngx-skeleton>
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                  <ng-template #blogFirstValueTemplate>
                    <div class="col-12 col-sm-12 col-md-6 col-lg-7 col-xl-7">
                      <div class="image-wrapper overflow-hidden">
                        <div class="ratio ratio-16x9" *ngIf="blogFirstValue?.youtube_url">
                          <iframe [src]="blogFirstValue.youtube_url | safe:'resourceUrl'" frameborder="0"
                            allowfullscreen></iframe>
                        </div>
                        <img alt="blog_image" src="{{blogFirstValue?.image_path}}" class="img-fluid" loading="lazy"/>

                      </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-6 col-lg-5 col-xl-5 info mt-3">
                      <span class="badge-blog ">
                        {{blogFirstValue?.type}}
                      </span>
                      <div class="date-time mb-1 mt-3">
                        {{blogFirstValue?.created_date | date: 'MMM dd yyyy'}}
                      </div>
                      <div class="blog-title cursor" (click)="gotoPath(blogFirstValue?.title,blogFirstValue?.id)"
                        [innerHTML]="blogFirstValue?.title">
                      </div>
                    </div>
                  </ng-template>
                </div>
                <div class="row g-3 mb-4">
                  <ng-container *ngIf="(blogAllList?.length == 0 && !productLoaded);else productTemplate">
                    <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 blog-items"
                      *ngFor="let item of skeletonService.generateFake(6);let i = index;">
                      <div class="row">
                        <div class="col-5 col-sm-4 col-md-12">
                          <div class="image-wrapper position-relative me-3 me-md-0 mb-3">
                            <ngx-skeleton height="250px"></ngx-skeleton>
                          </div>
                        </div>
                        <div class="col-7 col-sm-8 col-md-12">
                          <div class="content-box">
                            <div class="date-time mb-1">
                              <ngx-skeleton height="15px" width="150px"></ngx-skeleton>
                            </div>
                            <div class="blog-title ">
                              <ngx-skeleton height="15px"></ngx-skeleton>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </ng-container>
                  <ng-template #productTemplate>
                    <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 blog-items" *ngFor="let row of blogAllList | paginate: {
                                        itemsPerPage: itemsPerPage,
                                        currentPage: currentPage,
                                        totalItems: totalItems
                                      }; let i = index">
                      <div class="row">
                        <div class="col-5 col-sm-4 col-md-12">
                          <div class="image-wrapper position-relative me-3 me-md-0 mb-3">
                            <div class="ratio-16x9" *ngIf="blogFirstValue?.youtube_url">
                              <iframe class="vedio-h-w" *ngIf="row?.youtube_url"
                                [src]="row.youtube_url | safe:'resourceUrl'" frameborder="0" allowfullscreen></iframe>
                            </div>
                            <img alt="blog_image" *ngIf="row?.image_path" src="{{row?.image_path}}" class="img-fluid" loading="lazy"/>

                            <span class="badge-blog position-absolute">
                              {{row?.type}}
                            </span>
                          </div>
                        </div>
                        <div class="col-7 col-sm-8 col-md-12">
                          <div class="content-box">
                            <div class="date-time mb-1">
                              {{row?.created_date | date: 'MMM dd yyyy'}}
                            </div>
                            <div class="blog-title cursor" (click)="gotoPath(row.title,row.id)"
                              [innerHTML]="row?.title">
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </ng-template>
                </div>
              </div>
              <div class="tab-pane fade" id="pills-blogs" role="tabpanel" aria-labelledby="pills-blogs-tab">
                <div class="row g-4 mb-4">
                  <ng-container *ngIf="blogAllList?.length == 0 && !productLoaded;else productTemplate">
                    <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 blog-items"
                      *ngFor="let item of skeletonService.generateFake(6);let i = index;">
                      <div class="row">
                        <div class="col-5 col-sm-4 col-md-12">
                          <div class="image-wrapper position-relative me-3 me-md-0 mb-3">
                            <ngx-skeleton height="250px"></ngx-skeleton>
                          </div>
                        </div>
                        <div class="col-7 col-sm-8 col-md-12">
                          <div class="content-box">
                            <div class="date-time mb-1">
                              <ngx-skeleton height="15px"></ngx-skeleton>
                            </div>
                            <div class="blog-title ">
                              <ngx-skeleton height="15px"></ngx-skeleton>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </ng-container>
                  <ng-template #productTemplate>
                    <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 blog-items" *ngFor="let item of blogAllList | paginate: {
                                            itemsPerPage: itemsPerPage,
                                            currentPage: currentPage,
                                            totalItems: totalItems
                                          };let i = index">
                      <div class="image-wrapper position-relative mb-3">
                        <img alt="blog_image" src="{{item?.image_path}}" class="img-fluid" loading="lazy"/>
                        <span class="badge-blog position-absolute">
                          {{item?.type}}
                        </span>
                      </div>
                      <div class="date-time mb-1">
                        {{item?.created_date | date: 'MMM dd yyyy'}}
                      </div>
                      <div class="blog-title cursor" (click)="gotoPath(item.title,item.id)"
                        [innerHTML]="item?.title">
                      </div>
                    </div>
                  </ng-template>
                </div>
              </div>
              <div class="tab-pane fade" id="pills-videos" role="tabpanel" aria-labelledby="pills-videos-tab">
                <div class="row g-4 mb-4">
                  <ng-container *ngIf="blogAllList?.length == 0 && !productLoaded; else productTemplateVideo">
                    <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 blog-items"
                      *ngFor="let item of skeletonService.generateFake(6);let i = index;">
                      <div class="row">
                        <div class="col-5 col-sm-4 col-md-12">
                          <div class="image-wrapper position-relative me-3 me-md-0 mb-3">
                            <ngx-skeleton height="250px"></ngx-skeleton>
                          </div>
                        </div>
                        <div class="col-7 col-sm-8 col-md-12">
                          <div class="content-box">
                            <div class="date-time mb-1">
                              <ngx-skeleton height="15px"></ngx-skeleton>
                            </div>
                            <div class="blog-title ">
                              <ngx-skeleton height="15px"></ngx-skeleton>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </ng-container>
                  <ng-template #productTemplateVideo>
                    <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 blog-items" *ngFor="let item of blogAllList | paginate: {
                                            itemsPerPage: itemsPerPage,
                                            currentPage: currentPage,
                                            totalItems: totalItems
                                          };let i = index">
                      <div class="image-wrapper position-relative mb-3">
                        <img alt="{{item?.model}}" src="{{item?.image_path}}" class="img-fluid" loading="lazy"/>
                        <iframe class="vedio-h-w" *ngIf="item?.youtube_url"
                          [src]="item.youtube_url | safe:'resourceUrl'" frameborder="0" allowfullscreen></iframe>
                        <span class="badge-blog position-absolute">
                          {{item?.type}}
                        </span>
                      </div>
                      <div class="date-time mb-1">
                        {{item?.created_date | date: 'MMM dd yyyy'}}
                      </div>
                      <div class="blog-title cursor" (click)="gotoPath(item.title,item.id)"
                        [innerHTML]="item?.title">
                      </div>
                    </div>
                  </ng-template>
                </div>
              </div>
              <div class="tab-pane fade" id="pills-news" role="tabpanel" aria-labelledby="pills-news-tab">
                <div class="row g-4 mb-4">
                  <ng-container *ngIf="blogAllList?.length == 0 && !productLoaded;else productTemplate">
                    <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 blog-items"
                      *ngFor="let item of skeletonService.generateFake(6);let i = index;">
                      <div class="row">
                        <div class="col-5 col-sm-4 col-md-12">
                          <div class="image-wrapper position-relative me-3 me-md-0 mb-3">
                            <ngx-skeleton height="250px"></ngx-skeleton>
                          </div>
                        </div>
                        <div class="col-7 col-sm-8 col-md-12">
                          <div class="content-box">
                            <div class="date-time mb-1">
                              <ngx-skeleton height="15px"></ngx-skeleton>
                            </div>
                            <div class="blog-title ">
                              <ngx-skeleton height="15px"></ngx-skeleton>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </ng-container>
                  <ng-template #productTemplate>
                    <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 blog-items" *ngFor="let item of blogAllList | paginate: {
                                            itemsPerPage: itemsPerPage,
                                            currentPage: currentPage,
                                            totalItems: totalItems
                                          };let i = index">
                      <div class="image-wrapper position-relative mb-3">
                        <img alt="{{item?.model}}" src="{{item?.image_path}}" class="img-fluid" loading="lazy"/>
                        <span class="badge-blog position-absolute">
                          {{item?.type}}
                        </span>
                    </div>
                      <div class="date-time mb-1">
                        {{item.created_date | date: 'MMM dd yyyy'}}
                      </div>
                      <div class="blog-title cursor" (click)="gotoPath(item.title,item.id)"
                        [innerHTML]="item?.title">
                      </div>
                    </div>
                  </ng-template>
                </div>
              </div>
              <div class="row">
                <div class="paging-custom">
                  <pagination-controls *ngIf="totalItems > itemsPerPage" (pageChange)="pageChange($event)"
                    previousLabel=" " nextLabel=" " [maxSize]="6"></pagination-controls>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
